import {HttpVerbo, xfetch} from "../util";

export default class CirastServico {

  static getConfiguracaoCirast() {
    return xfetch("/cirast/controle-cirast", {}, HttpVerbo.GET)
  }

  static cadastrarConfiguracaoCirast(cmd) {
    return xfetch("/cirast/controle-cirast", cmd, HttpVerbo.PUT)
  }

  static reiniciarValorConsumidoCirast() {
    return xfetch("/cirast/controle-cirast", {}, HttpVerbo.PATCH)
  }

  static listarAtividadesConfiguracaoCirast() {
    return xfetch("/atividade/controle-cirast", {}, HttpVerbo.GET)
  }

  static cadastrarConsultaCirast(consulta) {
    console.log(consulta)
    return xfetch('/cirast/cadastrarConsulta/', consulta, HttpVerbo.POST)
  }

  static listarConsultasCirast() {
    return xfetch("/cirast/consultasPorCadastrante", {}, HttpVerbo.GET)
  }

  static listarConsultasCirastAdm(filtros) {
    let filtro = ''
    if (filtros && filtros.dtInicial) {
      filtro = '?idClinica='+filtros.idClinica+"&dtInicio="+filtros.dtInicial+'&dtFim='+filtros.dtFinal;
    }

    return xfetch("/cirast/consultas"+filtro, {}, HttpVerbo.GET)
  }

  static imprimir(id) {
    return xfetch("/cirast/imprimir", {id}, HttpVerbo.POST)
  }

  static registrarAtendimento(atendimento) {
    return xfetch('/publica/registrar/atendimento-cirast', atendimento, HttpVerbo.POST)
  }

  static consultarCep(cep) {
    return xfetch(`/cirast/consulta-cep/${cep}`, {}, HttpVerbo.GET)
  }

  static cadastrarClinica(clinica) {
    return xfetch('/cirast/clinica/cadastrar', clinica, HttpVerbo.POST)
  }
  static alterarClinica(clinica) {
    return xfetch('/cirast/clinica/alterar', clinica, HttpVerbo.PUT)
  }
  static ativarInativar(clinica) {
    return xfetch('/cirast/clinica/ativar-inativar', clinica, HttpVerbo.PUT)
  }

  static consultarClinica() {
    return xfetch(`/cirast/clinica`, {}, HttpVerbo.GET)
  }

  static buscarRelatorio(relatorioCmd) {
    return xfetch(`/cirast/relatorio`, relatorioCmd, HttpVerbo.POST)
  }

  static buscarRelatorioXls(relatorioCmd) {
    return xfetch(`/cirast/relatorio/xls`, relatorioCmd, HttpVerbo.POST)
      .then( res => res.blob() )
      .then( blob => {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = "relatorio_cirast.xls";
        a.click();
      });
  }

  static cadastrarTipoAtendimento(data) {
    return xfetch('/cirast/tipoAtendimento', data, HttpVerbo.POST)
  }

  static alterarTipoAtendimento(data) {
    return xfetch('/cirast/tipoAtendimento', data, HttpVerbo.PUT)
  }

  static getTipoAtendimento() {
    return xfetch('/cirast/tipoAtendimento', {}, HttpVerbo.GET)
  }

  static buscarRelatorioPdf(relatorioCmd) {
    return xfetch(`/cirast/relatorio/pdf`, relatorioCmd, HttpVerbo.POST)
      .then( res => res.blob() )
      .then( blob => {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = "relatorio_cirast.pdf";
        a.click();
      });
  }

  static removerConsulta(idConsulta) {
    return xfetch('/cirast/consulta/remover', {'idConsulta': idConsulta},  HttpVerbo.POST)
  }

  static inativarConsulta(id) {
    return xfetch('/cirast/consulta/inativar', {'idConsulta': id},  HttpVerbo.POST)
  }

  static getConsultaPorId(id) {
    return xfetch(`/cirast/consulta/${id}`, {}, HttpVerbo.GET)
  }
}
